export default __webpack_public_path__ + "media/images/theme/bg_light-71ca3f49b7848d218f9a2e931e7bcfe3.png";